<template>
<!-- Inst icons component called to display icons throughout portal -->
  <b-img
    class="inst-icons"
    :src="instIcons[instAT]"
    v-bind="thumbnailProps"
    rounded="0"
  ></b-img>
</template>

<script>
/**
 * Instrument icon component.
 */
import { instIcons } from './staticGeom';

export default {
  props: ['instAT'],
  data() {
    return {
      instIcons,
      thumbnailProps: { width: 30, height: 30, class: 'm1' },
    };
  },
};
</script>
<style>
.inst-icons {
  margin-right: 0.25rem;
}
</style>
